@if (parsedData.organizer || parsedData.title) {
  <div
    attr.aria-label="{{'event.organizer' | translate}} {{ parsedData.organizer || parsedData.title }}"
    >
    {{ parsedData.organizer || parsedData.title }}
  </div>
}
@if ((parsedData.person || parsedData.fieldRegistrationCode) && type !== 'studyProgramme') {
  <div
    attr.aria-label="{{'event.person' | translate}} {{ parsedData.person || parsedData.fieldRegistrationCode }}"
    >
    {{ parsedData.person || parsedData.fieldRegistrationCode }}
  </div>
}
@if (parsedData.fieldSchoolWebsite && type === 'studyProgramme') {
  <a
    href="{{ parsedData.fieldSchoolWebsite }}"
    target="_blank"
    attr.aria-label="{{'event.contact' | translate}} {{ parsedData.fieldSchoolWebsite }}"
    [attr.data-test-id]="'sidebar-contact-link-' + (parsedData?.fieldSchoolWebsite | slugify)"
    >{{ parsedData.fieldSchoolWebsite }}</a
    >
  }
  @if (parsedData.phone) {
    <a
      href="tel:{{ parsedData.phone }}"
      attr.aria-label="{{'event.phone' | translate}} {{ parsedData.phone }}"
      [attr.data-test-id]="'sidebar-contact-link-' + (parsedData?.phone)"
      >{{ parsedData.phone }}</a
      >
    }
    @if (parsedData.email) {
      <a
        href="mailto:{{ parsedData.email }}"
        attr.aria-label="{{'event.email' | translate}} {{ parsedData.email }}"
        [attr.data-test-id]="'sidebar-contact-link-' + (parsedData?.email)"
        >{{ parsedData.email }}</a
        >
      }
      @if (parsedData.webpage) {
        <a
          href="{{ parsedData.webpage }}"
          attr.aria-label="{{'event.contact' | translate}} {{ parsedData.webpage }}"
          [attr.data-test-id]="'sidebar-contact-link-' + (parsedData?.webpage | slugify)"
          >{{ parsedData.webpage | removeProtocol }}</a
          >
        }
